import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { PortalConfigurationView } from '../models/PortalConfigurationView';

@Injectable({
  providedIn: 'root',
})
export class LookupService {
  private readonly urlPath = 'lookup';

  constructor(private httpClient: HttpClient) {}

  getPortalConfiguration(): Observable<PortalConfigurationView> {
    return this.httpClient
      .get<PortalConfigurationView>(
        `${environment.apiUrl}${this.urlPath}/portal-configuration`,
      )
      .pipe();
  }
}
